import styled from "styled-components";
import {themeFontSize} from "ui/theme";

export const CancellationPolicyContent = ({
                                              policy = [],
                                              fullName = "Teacher",
                                          }) => (
    <Container>

        {!!policy?.length ? (
            <>
                <StyledTitle>{fullName} Cancellation Policy</StyledTitle>
                {policy.map(({percentage, policy}, index) => (
                    <StyledTypography key={index}>
                        If you cancel {policy.toLowerCase()} before the class start time,
                        you will receive a {percentage}% refund
                    </StyledTypography>
                ))}
            </>
        ) : null}
        <StyledTitle>Teache Cancellation Policy</StyledTitle>
        <StyledTypography>
            If you cancel within 1 hour of the class start time, you won't receive
            any refund.
        </StyledTypography>
    </Container>
);

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 0.5rem;
`;

const StyledTitle = styled.span`
    font-size: ${themeFontSize("regular")};
    font-weight: 600;
    text-align: center;
`;

const StyledTypography = styled.p`
    font-size: ${themeFontSize("regular")};
    font-weight: 400;
`;
